import {CanBeSignals, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {coreStore} from '@gongxigames/framework/core/globals';
import {Container as PixiContainer} from 'pixi.js';
import {ActionFunction} from './Wrap';
import {EaseFunction} from '@gongxigames/framework/core/fragments/tween/Easing';
import {UpdateManager} from '@gongxigames/framework/core';

export type OnUpdateFunction<T extends PixiContainer> = (instance: T, progress: number) => void;
export type onCompleteFunction<T extends PixiContainer> = (instance: T, progress: number) => void;

export type TweenProps<T extends PixiContainer> = CanBeSignals<{
    to: Partial<T>;
    duration: number;
    updater?: UpdateManager;
    delay?: number;
    easing?: EaseFunction;
    onUpdate?: OnUpdateFunction<T>;
    onComplete?: onCompleteFunction<T>;
}>;

export function Tween<T extends PixiContainer>(props: TweenProps<T>): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        const updater = getProp(props.updater) ?? coreStore.updateManager.value!;
        const to = getProp(props.to);
        const duration = getProp(props.duration);
        const delay = getProp(props.delay);
        const easing = getProp(props.easing);
        const onUpdate = getProp(props.onUpdate);
        const onComplete = getProp(props.onComplete);

        const tween = updater
            .addTween(instance)
            .to(to, duration);

        if (delay) {
            tween.delay(delay);
        }

        if (easing) {
            tween.easing(easing);
        }

        if (onUpdate) {
            tween.onUpdate(onUpdate);
        }

        if (onComplete) {
            tween.onComplete(onComplete);
        }

        tween.onComplete(done);
        tween.start();
    };

    return result;
};
